import type { Section } from "components/_ProductConfigurator/store/ProductConfiguration.types";

export const extractInitialValues = (sections: Section[]) => {
  const values: Record<string, boolean> = {};

  sections?.forEach((section) => {
    section?.groups?.forEach((group) => {
      group?.controls?.forEach((control) => {
        if (control.boolValue) {
          values[control.id] = true;
        }
      });
    });
  });

  return values;
};
